const DEFAULT_ENDPOINT = process.env.REACT_APP_PROCTORING_LOG_ENDPOINT || '';

const buildPayload = (token, type, meta = {}) => ({
  token: token || undefined,
  type,
  meta,
  timestamp: new Date().toISOString()
});

export const logViolation = async (token, type, meta = {}) => {
  if (!type) {
    return Promise.resolve();
  }

  const payload = buildPayload(token, type, meta);
  
  // Always log to console for debugging
  console.log('[proctoring] violation captured:', {
    type,
    meta,
    timestamp: payload.timestamp
  });

  // Store violations in localStorage for frontend-only mode
  try {
    const stored = localStorage.getItem('proctoring_violations');
    const violations = stored ? JSON.parse(stored) : [];
    violations.push(payload);
    // Keep only last 100 violations to avoid filling localStorage
    if (violations.length > 100) {
      violations.shift();
    }
    localStorage.setItem('proctoring_violations', JSON.stringify(violations));
  } catch (error) {
    console.warn('[proctoring] failed to store violation locally', error);
  }

  const endpoint = DEFAULT_ENDPOINT.trim();

  // If no endpoint configured, just work frontend-only
  if (!endpoint) {
    return Promise.resolve();
  }

  // Try to send to backend if endpoint is available
  try {
    await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(payload)
    });
  } catch (error) {
    // Silently fail - we've already stored locally
    console.warn('[proctoring] failed to send violation to backend (working frontend-only)', error);
  }
};



